"use client";

import { Button, Card, CardContent, CardHeader } from "@heroui/react";
import { useRouter, useSearchParams } from "next/navigation";
import { useTranslations } from "next-intl";

export default function AuthError() {
  const t = useTranslations("auth error");
  const router = useRouter();
  const searchParams = useSearchParams();
  const error = searchParams.get("error");

  const getErrorMessage = () => {
    switch (error) {
      case "Configuration":
        return t("configuration");
      case "AccessDenied":
        return t("access denied");
      case "Verification":
        return t("verification");
      default:
        return t("default");
    }
  };

  return (
    <div className="container mx-auto flex min-h-screen items-center justify-center px-6">
      <Card className="w-full max-w-md">
        <CardHeader className="flex flex-col gap-2">
          <h1 className="text-2xl font-semibold">{t("title")}</h1>
        </CardHeader>
        <CardContent className="flex flex-col gap-4">
          <p className="text-danger">{getErrorMessage()}</p>
          <Button variant="primary" onPress={() => router.push("/auth")}>
            {t("try again")}
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
